import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { filterNullish } from '@shared/helpers/helpers';
import { Observable, map } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { AuthService, EUAV3UserInfo } from '@shared/auth/auth.service';
import { SessionService } from '@services/session.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  imports: [RouterLink, NzIconModule, AsyncPipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class NavbarComponent {
  displayName$: Observable<string>;

  @Input() isMobile = false;
  changeIcon = false;

  constructor(
    private readonly authService: AuthService,
    private readonly sessionService: SessionService,
  ) {
    this.displayName$ = this.authService.pingUserInfo$.pipe(
      map((userInfo: EUAV3UserInfo) => userInfo?.displayName as string),
      filterNullish,
      map((displayName) => displayName.split(', ').reverse().join(' ')),
    );
    this.sessionService.navMenuStatus$.subscribe((newStatus: boolean) => {
      this.changeIcon = newStatus;
    });
  }

  toggleNavMenu() {
    this.sessionService.toggleNavMenu();
  }
}
